module.exports = __webpack_public_path__ + "img/google_play2x.f1ddd563.png";